export default "__VITE_ASSET__BmfEyIeR__"